import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'
import { EMITS as SLIDER_EMITS } from './Slider'

export default class JobStoryModalContent extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            slider: null,
            placeholder: null
        }

        this.slider = null
    }

    prepare() {
        if (this.ref.slider) {
            this.slider = Component.getFromElement(this.ref.slider)
            this.slider.on(SLIDER_EMITS.SELECTED, this.handleSliderItemSelected)
        }

        EventBus.on(EVENTS.MODAL_OPEN, this.handleModalOpen)
    }

    destroy() {
        EventBus.off(EVENTS.MODAL_OPEN, this.handleModalOpen)
    }

    handleSliderItemSelected = event => {
        const cell = this.slider.flickity.cells[event.index]
        if (!cell) {
            return
        }

        cell.element.offsetHeight

        this.slider.element.querySelector('.flickity-viewport').style.transition = `.3s height linear`
        this.slider.element.querySelector('.flickity-viewport').style.height = `${cell.element.offsetHeight}px`
    }

    handleModalOpen = event => {
        const modal = event.modal
        if (!modal.element.contains(this.element)) {
            return
        }

        const storyId = event.data.storyId
        if (!storyId) {
            return
        }

        const handleResizeEnd = () => {
            const flickity = this.slider.flickity
            if (!flickity) {
                return
            }

            const index = flickity.cells.findIndex(cell => cell.element.dataset.storyId === storyId)
            if (index < 0) {
                return
            }
            this.slider.select(index)
            this.slider.off(SLIDER_EMITS.RESIZE_END, handleResizeEnd)
        }

        this.slider.on(SLIDER_EMITS.RESIZE_END, handleResizeEnd)
        this.slider.resize()
    }
}